






























import {
  Component, Vue, Prop, Watch, Ref,
} from 'vue-property-decorator';
import EmailTimerButton from '@/EmailTimerButton';
import { updateMail } from 'service/api';
import { ElForm } from 'element-ui/types/form.d';

@Component({
  components: { EmailTimerButton },
})
export default class EmailInfo extends Vue {
  @Ref('form') readonly form!: ElForm;

  @Prop(String) email!: string;

  @Watch('email')
  onValueChange(val: string) {
    this.emailInfo.email = val;
  }

  emailInfo = {
    email: '',
    code: '',
  };

  emailRules = {
    email: [
      {
        required: true,
        pattern: /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,}$/,
        message: '请输入正确的邮箱地址',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true, pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur',
      },
    ],
  };

  loading = false;

  submit() {
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        try {
          const res = await updateMail({
            mailaddress: this.emailInfo.email,
            sendCode: this.emailInfo.code,
          }) as { state: boolean; message: string };
          if (res.state) {
            this.$message.success('绑定成功！');
            this.$emit('change');
          } else {
            this.$notify.error(res.message);
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  mounted() {
    this.emailInfo.email = this.email;
  }
}
